module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "welcome"
  }, [_vm._l((_vm.steps), function(step, i) {
    return (_vm.active === i) ? _c(step, {
      tag: "component",
      on: {
        "next": _vm.next
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('el-steps', {
    attrs: {
      "space": 50,
      "active": _vm.active,
      "direction": "vertical",
      "finish-status": "success"
    }
  }, _vm._l((_vm.steps), function(step) {
    return _c('el-step', {
      attrs: {
        "title": _vm.$t('step.' + step)
      }
    })
  }))], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-35639562!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/setup-guide/Welcome.vue
// module id = 1143
// module chunks = 2